import { useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'
import { DIALOGS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  open: boolean
  currentName: string
  onClose: () => void
  onSubmit: (name: string) => void | Promise<void>
  isSubmitting?: boolean
  error?: string | null
}

export function CollectionRenameDialog({
  open,
  currentName,
  onClose,
  onSubmit,
  isSubmitting = false,
  error = null,
}: Props) {
  const [name, setName] = useState(currentName)

  useEffect(() => {
    if (open) setName(currentName)
  }, [open, currentName])

  const trimmed = name.trim()
  const canSubmit = trimmed.length > 0 && !isSubmitting

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{DIALOGS.renameCollection}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1, minWidth: 320 }}>
          <TextField label={DIALOGS.name} value={name} onChange={(e) => setName(e.target.value)} />
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{DIALOGS.cancel}</Button>
        <Button onClick={() => onSubmit(trimmed)} disabled={!canSubmit} variant="contained">
          {DIALOGS.save}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
